import { Box, Button } from '@mui/material'
import { useState } from 'react'
import FilePicker from '../../Components/FilePicker'
import { BannerModal } from '../../Components/Modal/BannerModal'
import { type ReferralDocumentModel, type DocumentVerifyModel, type DocumentTarget } from '../../core/types'
import { GeneralDocumentSelection } from './GeneralDocumentSelection'
import { type DocumentData } from '../../Components/DocumentList/DocumentInfo'

export interface GeneralDocumentProps {
  documentTypeId: number
  documentTarget: DocumentTarget
  childName: string
  referenceType: string
  referenceId: number
  incomeRelated: boolean
  childID: number
  readOnly: boolean
  years: number[]
  onDocumentUploaded: (file: File, documentTarget: DocumentTarget) => Promise<void>
  onDocumentAttach: (docs: DocumentData[]) => Promise<void>
}

export interface GeneralDocumentTypeModel {
  documentTypeID: number
  documentTypeName: string
  documentDescription: string | null
  imageFile: string | null
  incomeRelated: boolean
  verifiedIncomeTotal: number | null
  caregiverRelated: boolean
  documentsUploaded: number
  required: boolean
  documents: ReferralDocumentModel[]
}

export function GeneralDocumentUploader (props: GeneralDocumentProps): JSX.Element {
  const [showSelectedDocuments, setShowSelectedDocuments] = useState<boolean>(false)
  const [existingDocuments, setExistingDocuments] = useState<DocumentData[]>([])
  const handleSetExistingDocs = (docs: DocumentVerifyModel[]): void => {
    setExistingDocuments(docs.map(d => translateDocData(d)))
  }
  const translateDocData = (doc: DocumentVerifyModel): DocumentData => {
    return {
      caregivers: doc.caregivers?.map(c => {
        return {
          caregiverID: c.caregiverID,
          caregiverName: c.name,
          selected: c.selected
        }
      }),
      childName: props.childName,
      documentID: doc.documentID,
      documentTypeID: doc.documentTypeID ?? 0,
      documentTarget: props.documentTarget,
      fileName: doc.fileName ?? '',
      incomeAmount: doc.incomeAmount,
      incomeRelated: doc.incomeRelated,
      incomeYear: doc.incomeYear,
      inUse: false,
      verificationNote: doc.verifyNotes,
      verified: doc.isVerified,
      verifiedBy: doc.verifiedBy,
      verifiedDate: doc.verifiedOn ?? new Date()
    }
  }
  const uploadAndVerify = async (file: File): Promise<void> => {
    void props.onDocumentUploaded(file, props.documentTarget)
  }

  const attachExistingDocument = async (): Promise<void> => {
    if (existingDocuments.length > 0) {
      void props.onDocumentAttach(existingDocuments)
      setShowSelectedDocuments(false)
    }
  }

  return <>
    <div className='mt-5'>
      <Box sx={{ justifySelf: 'center' }}>
        {!props.readOnly && <>
          <FilePicker
            label='Upload a file'
            name='file'
            onSelect={async (e: any): Promise<void> => { await uploadAndVerify(e.target.files[0]) }}
          />
          <Button variant='outlined' color='inherit' className='ml-10' data-testid='selectExisting'
            onClick={() => { setShowSelectedDocuments(true) }}
          > Select Existing</Button>
        </>
        }
      </Box >
    </div>
    {showSelectedDocuments && <BannerModal
      open={true}
      dataTestId='selectDocumentsBanner'
      title={'Available Documents'}
      onConfirm={attachExistingDocument}
      confirmButtonText='Save'
      onClose={() => { setShowSelectedDocuments(false) }}
      hideXtoClose={true}
      className='Nested Referral'
      content={<GeneralDocumentSelection
        referenceType={props.referenceType}
        referenceID={props.referenceId}
        documentTypeID={props.documentTypeId}
        incomeRelated={props.incomeRelated}
        onInclude={handleSetExistingDocs}
        years={props.years}
      />}
    />
    }
  </>
}
